import React from "react";
import {
  Button,
  Form,
  FormGroup,
  FormInput,
  Row,
  Col,
  FormFeedback,
} from "shards-react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";

const axios = require("axios").default;
const FormResetPassword = (props) => {
  const { onChangeStatus } = props;
  const { t, i18n } = useTranslation();
  const validate = (values) => {
    const errors = {};
    if (!values.password) {
      errors.password = "กรุณาระบุรหัสผ่านใหม่";
    }
    if (!values.confirmpassword) {
      errors.confirmpassword = "กรุณาระบุยืนยันรหัสผ่าน";
    } else if (values.password !== values.confirmpassword) {
      errors.confirmpassword = "รหัสผ่านไม่ตรงกัน";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmpassword: "",
    },
    validate,
    onSubmit: (values) => {
      axios
        .post("/v1/auth/resetPassword", JSON.stringify(values, null, 2))
        .then(function(response) {
          onChangeStatus(4);
        })
        .catch(function(error) {
          console.log(error);
          onChangeStatus(4);
        });
    },
  });
  // const onComfirmPassword = () => {
  //     onChangeStatus(5)
  // }
  return (
    <>
      <h6 className="bold text-center">{t("common:resetPassword.ForgotPassword")}</h6>
      <h6 className="bold">{t("common:resetPassword.ChangeNewPassword")}</h6>
      <Form onSubmit={formik.handleSubmit}>
        <FormGroup>
          <label>
            {t("common:resetPassword.NewPassword")}
            <span className="color-red">*</span>
          </label>
          <FormInput
            type="password"
            name="password"
            placeholder={t("common:resetPassword.NewPassword")}
            onChange={formik.handleChange}
            invalid={!!formik.errors.password}
            value={formik.values.password}
          />
          {formik.errors.password && (
            <FormFeedback>{formik.errors.password}</FormFeedback>
          )}
        </FormGroup>
        <FormGroup className="mb-5">
          <label>
            {t("common:resetPassword.ReconfirmPassword")}
            <span className="color-red">*</span>
          </label>
          <FormInput
            type="password"
            name="confirmpassword"
            placeholder={t("common:resetPassword.ReconfirmPassword")}
            onChange={formik.handleChange}
            invalid={!!formik.errors.confirmpassword}
            value={formik.values.confirmpassword}
          />
          {formik.errors.confirmpassword && (
            <FormFeedback>{formik.errors.confirmpassword}</FormFeedback>
          )}
        </FormGroup>
        <hr />
        <Row>
          <Col md="6">
            <Button
              className="btn btn-white w-100 mb-3"
              onClick={() => onChangeStatus(3)}
            >
              {`${t("common:resetPassword.Back")}`}
            </Button>
          </Col>
          <Col md="6">
            <Button type="submit" className="btn btn-success w-100 mb-3">
              ${t("common:resetPassword.ConfirmPassword")}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FormResetPassword;
